<div class="site-footer__widget footer-contacts">
    <a class="footer-contacts__logo" routerLink="/" [attr.aria-label]="'brand-home' | t:'{brand} home':{ brand: brand.name }">
        <app-brand-logo></app-brand-logo>
    </a>

    <h4 class="footer-contacts__title">{{ 'primehat-tagline' | t:'Shop from Verified Sellers Across Bangladesh' }}</h4>

    <!-- The entity sentence (ENTITY_SENTENCE): the same words wherever the shop says what it is. -->
    <div class="footer-contacts__text">{{ 'primehat-entity-sentence' | t:'PrimeHat is an online marketplace in Bangladesh where verified sellers list electronics, fashion, home and everyday products, with delivery across all 64 districts. Sellers run their shops on PrimeCommerce, PrimeHat\'s seller platform.' }}</div>

    <!-- Each contact is one row: an icon badge beside a label and its value, the whole row the link.
         The sprite icons sat on a line of their own (app-icon is display: block) and the shop-location
         one is an illustration that turns to noise at 16px, so these are line icons drawn here.
         No email address: the shop publishes none (the owner, 2026-09-27) - an address on every page is
         harvested for spam - and the contact form is the way in. No company row (the owner, 2026-10-22):
         the company is named in the copyright line below and in the legal notice, the terms' "Who we are". -->
    <ul class="footer-contacts__list" *ngIf="company$ | async as c">
        <li>
            <a class="footer-contacts__row" routerLink="/contact">
                <span class="footer-contacts__badge" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M4 5.5h16a1 1 0 0 1 1 1v9.5a1 1 0 0 1-1 1H9.5L5 20.5V17H4a1 1 0 0 1-1-1V6.5a1 1 0 0 1 1-1z" /><path d="M7.5 10h9M7.5 13h6" /></svg>
                </span>
                <span class="footer-contacts__body">
                    <span class="footer-contacts__label">{{ 'support-label' | t:'Customer support' }}</span>
                    <span class="footer-contacts__value">{{ 'send-us-a-message' | t:'Send us a message' }}</span>
                    <span class="footer-contacts__meta">{{ 'we-answer-by-email' | t:'We answer every message by email' }}</span>
                </span>
            </a>
        </li>
        <li *ngIf="c.phone">
            <a class="footer-contacts__row" href="tel:{{ c.phone }}">
                <span class="footer-contacts__badge" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><rect x="7" y="2.5" width="10" height="19" rx="2" /><path d="M11 18.5h2" /></svg>
                </span>
                <span class="footer-contacts__body">
                    <span class="footer-contacts__label">{{ 'call-us' | t:'Call us' }}</span>
                    <span class="footer-contacts__value">{{ c.phone }}</span>
                </span>
            </a>
        </li>
    </ul>
</div>
